import icon from "@material-ui/icons/SupervisorAccount"

export default { icon } ;